import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph } from '../../../legacy/hui/src/styled';

const Questions = ({ questions }) => (
  <div>
    {questions.map(({ question, answers, id }) => (
      <div key={id} style={{ marginBottom: '1rem' }}>
        <Paragraph mb={0} style={{ fontWeight: 600 }}>
          {question}
        </Paragraph>
        <Paragraph mb={0}>{answers.map(({ answer }) => answer).join(', ')}</Paragraph>
      </div>
    ))}
  </div>
);

Questions.propTypes = {
  questions: PropTypes.array
};

export default Questions;
